import React, { FC } from 'react';

import { GradientColor } from 'views/OfferDesign/OfferDesign.types';

import { cn } from 'components/lib/utils';
import { ColorPicker } from 'components/ui/ColorPicker/color-picker';

import {
  FieldLayout,
  FIELD_LAYOUT_MAP,
  GradientFieldConfig,
  Spacing,
  SPACING_MAP
} from '../FormFields.types';
import { getFormFieldValue } from '../FormFields.utils';

import { useFormFieldsContext } from '../../../context';

interface IFormFieldsColorRowProps {
  fields: GradientFieldConfig[];
  spacing?: Spacing;
  layout?: FieldLayout;
}

export const FormFieldsColorRow: FC<IFormFieldsColorRowProps> = ({
  fields,
  spacing = 'none',
  layout = 'full'
}): React.ReactElement => {
  const { values, setFieldValue } = useFormFieldsContext();

  return (
    <div className={cn('flex gap-5', SPACING_MAP[spacing], FIELD_LAYOUT_MAP[layout])}>
      {fields.map(
        ({
          header,
          name,
          fallback,
          dataTestId
        }: GradientFieldConfig): React.ReactElement => {
          const currentValue = getFormFieldValue<GradientColor>(values, name);
          return (
            <div key={name} className="flex-1">
              <ColorPicker
                label={header}
                data-testid={dataTestId}
                defaultValue={currentValue?.colorOne || fallback.colorOne}
                onChange={(color) => setFieldValue(name, { colorOne: color })}
              />
            </div>
          );
        }
      )}
    </div>
  );
};
